import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { CheckIcon, XIcon } from 'lucide-react';
export function WhoIsThisFor() {
  const isFor = ['Mujeres de 40 a 60 años que viven en Estados Unidos.', 'Latinas que sufren de insomnio, sudores nocturnos y fatiga crónica.', "Profesionales que sienten que la 'neblina mental' está afectando su rendimiento.", 'Quienes buscan una solución natural, práctica y basada en comida real.'];
  const notFor = ['Personas que buscan una pastilla mágica para no cambiar sus hábitos.', 'Hombres o mujeres jóvenes que no están en transición hormonal.', 'Personas que no están dispuestas a leer etiquetas en el supermercado.'];
  return <SectionWrapper className="bg-brand-surface" data-id="element-176">
      <div className="max-w-5xl mx-auto" data-id="element-177">
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-178">
          {/* For */}
          <div className="bg-white p-8 rounded-3xl shadow-sm border-t-8 border-brand-sage" data-id="element-179">
            <h3 className="font-serif text-2xl font-bold text-brand-brown mb-6 flex items-center" data-id="element-180">
              <span className="bg-brand-sage/20 text-brand-sage p-2 rounded-full mr-3" data-id="element-181">
                <CheckIcon className="w-6 h-6" data-id="element-182" />
              </span>
              Esto es para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-183">
              {isFor.map((item, index) => <li key={index} className="flex items-start" data-id="element-184">
                  <CheckIcon className="w-5 h-5 text-brand-sage mt-1 mr-3 flex-shrink-0" data-id="element-185" />
                  <span className="font-sans text-brand-brown/80 text-lg" data-id="element-186">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* Not For */}
          <div className="bg-white p-8 rounded-3xl shadow-sm border-t-8 border-brand-terracotta" data-id="element-187">
            <h3 className="font-serif text-2xl font-bold text-brand-brown mb-6 flex items-center" data-id="element-188">
              <span className="bg-brand-terracotta/20 text-brand-terracotta p-2 rounded-full mr-3" data-id="element-189">
                <XIcon className="w-6 h-6" data-id="element-190" />
              </span>
              Esto NO es para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-191">
              {notFor.map((item, index) => <li key={index} className="flex items-start" data-id="element-192">
                  <XIcon className="w-5 h-5 text-brand-terracotta mt-1 mr-3 flex-shrink-0" data-id="element-193" />
                  <span className="font-sans text-brand-brown/80 text-lg" data-id="element-194">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}